import { useEffect } from "react";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { IFullClientResponse } from "./type.ts";


type useFullClientsParams = {
  search: string;
  page: number;
  pageSize: number;
  sortBy: string;
  sortDirection: string;
};

export const useFullClients = (params: useFullClientsParams) => {
  const { token } = useAuth();
  const { pageSize, page, search, sortBy, sortDirection } = params;

  const fetch = useFetch();

  const { data, isLoading, isError, error } = useQuery<
    IFullClientResponse | null,
    Error,
    IFullClientResponse
  >({
    queryKey: ["full-clients", search, pageSize, page, sortDirection, sortBy],
    enabled: !!(pageSize && page),
    queryFn: () =>
      fetch<IFullClientResponse>(`${Urls.FullClients}?PageNumber=${page}&PageSize=${pageSize}&SortBy=${sortBy}&SortDirection=${sortDirection}&${search ? `Search=${search}&` : ""}`, {
        method: "GET",
      }, true, token),
    staleTime: 0,
    gcTime: 0
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Error full clients info");
    }
  }, [error?.message, isError]);

  return {
    data,
    isFetching: isLoading,
  };
};
